import { Instance, types } from 'mobx-state-tree'

const Notification = types.model('Notification', {
  id: types.string,
  date: types.string,
  title: types.string,
  message: types.string,
  isRead: types.boolean,
  url: types.string,
})

const notificationDataV2 = Notification.create({
  id: '1',
  date: '12 days ago',
  title: 'Privacy Policy Updated!',
  message:
    'we have updated our privacy policy to clarify what information we collect, how we use it, and how we comply with applicable laws.',
  isRead: false,
  url: 'https://www.google.com/',
})
const notificationData0V2 = Notification.create({
  id: '2',
  title: 'Privacy Policy Updated!',
  message:
    'We have updated our Privacy Policy to clarify what information we collect, how we use it, and how we comply with applicable laws.',
  isRead: true,
  date: '12 days ago',
  url: 'https://www.google.com/',
})

export { Notification, notificationDataV2, notificationData0V2 }
export type NotificationV2 = Instance<typeof Notification>
